<div *ngIf="isVisible"
     class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
     [@slideIn]>
  <div class="bg-white rounded-lg shadow-xl max-w-md w-full">
    <div class="p-6">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-xl font-semibold text-gray-900">Install Our App</h3>
        <button (click)="close()" class="text-gray-400 hover:text-gray-500">
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="space-y-4">
        <div class="flex items-center space-x-3">
          <div
            class="flex-shrink-0 w-8 h-8 bg-gradient-to-r from-[#E3D7FF] to-[#5810FF] rounded-full flex items-center justify-center text-white">
            1
          </div>
          <p>Tap the share button in your browser's menu</p>
        </div>

        <div class="flex items-center space-x-3">
          <div
            class="flex-shrink-0 w-8 h-8 bg-gradient-to-r from-[#5810FF] to-[#E3D7FF] rounded-full flex items-center justify-center text-white">
            2
          </div>
          <p>Select 'Add to Home Screen' or 'Install App'</p>
        </div>

        <div class="flex items-center space-x-3">
          <div
            class="flex-shrink-0 w-8 h-8 bg-gradient-to-r from-[#E3D7FF] to-[#5810FF] rounded-full flex items-center justify-center text-white">
            3
          </div>
          <p>Tap 'Add' or 'Install' in the prompt</p>
        </div>
      </div>

      <div class="mt-6">
        <button (click)="close()"
                class="w-full px-4 py-2 text-white rounded-md bg-gradient-to-r from-[#E3D7FF] to-[#5810FF]">
          Got it!
        </button>
      </div>
    </div>
  </div>
</div>
